<template>
    <div class="AllBox">
      <van-sticky>
        <!-- <van-nav-bar title="编辑昵称" left-arrow safe-area-inset-top @click-left="onClickLeft" /> -->
        <Nav title="编辑昵称"></Nav>
      </van-sticky>
  
      <div class="mainBox">
        <van-field class="inputField" clearable center :placeholder="state.name" v-model="state.inputText" maxlength="10"></van-field>
  
          <div :class="nickOK() == true ? 'bottomV' : 'bottomVGray'" @click="onQuit">
            <span>保存</span>
          </div>
      </div>
    </div>
  </template>
    
  <script>
  import { onMounted, reactive } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import { Toast } from "vant";
  import SDK from "@yxim/nim-web-sdk";
  import router from '@/router';
  import { useStore } from "vuex";
import { onDeactivated } from "vue";
import { onActivated } from "vue";
import { getQueryString } from "../../utils/location";
  
  export default {
    name: "ResetGroupName",
    setup() {
      const router = useRouter();
      const route = useRoute();
      const store = useStore();
      const state = reactive({
        teamData: {},
        nim: null,
        name: '',
        uid: store.state.id,
        teamId: '12553569744',
        userAccount: '',
        inputText: "",
      })
  
      //判断
      const nickOK = () => {
        if (state.name != state.inputText && state.inputText.length > 1) {
          return true;
        } else {
          return false;
        }
      };
      // 返回
      const onClickLeft = () => {
        router.back();
      };
      //更改群昵称
      const onQuit = () => {
        if (nickOK() == false) {
          Toast("请输入昵称");
          return;
        }
        // console.log(state);
        state.nim.updateNickInTeam({
          teamId: state.teamId,
          nickInTeam: state.inputText,
          account: state.userAccount,
          done:updateNickInTeamDone,
        });
      };
      const updateNickInTeamDone = (error, obj) => {
        console.log(error);
        // console.log(obj);
        console.log("修改群成员的昵称" + (!error ? "成功" : "失败"));
        if (!error) {
            Toast("修改成功");
          router.go(-1);
        }
      };
      onActivated(() => {
        // console.log("mounted初始化uid -----------------------------------", state.uid);


        window.scrollTo(0, 0);
        console.log("mounted");
        state.name = getQueryString("name");
        state.teamId = getQueryString("teamId");
        state.userAccount = getQueryString("userAccount");
        //初始化IM
        // this.nim = SDK.NIM.getInstance();
        state.nim = SDK.NIM.getInstance({
          // 初始化SDK
          debug: true,
          appKey: store.state.appKey,
          account:store.state.wyAccount,
          token:store.state.wyToken,
          debugLevel: "debug",
          db: false,
        });
      });
      onDeactivated(() => {
        console.log("离开");
        state.name = "";
        state.teamId = "";
        state.userAccount = "";
        state.inputText = "";
      });
      return {
        state,
        nickOK,
        onClickLeft,
        onQuit,
        updateNickInTeamDone
       }
    },
  }
  
  
  </script>
    
  <style scoped="scoped">
  .AllBox {
    background-color: #fff;
  }
  
  .mainBox {
    /* height: 2000px; */
    /* height: 100vh; */
    background-color: #fff;
    padding: 32px;
  }
  
  .mainBox p {
    font-size: 24px;
    color: #333;
    margin-top: 24px;
    margin-bottom: 22px;
  }
  
  .inputField {
    height: 88px;
    border-radius:16px;
    background-color: #f8f8f8;
    padding: 30px 24px;
  }
  
  .bottomV {
    /* position: fixed;
    bottom: 100px; */
    text-align: center;
    background-color: #9C85FB;
    color: #fff;
    width: 680px;
    height: 72px;
    margin: 64px auto;
    border-radius: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .bottomVGray {
    /* position: fixed;
    bottom: 100px; */
    text-align: center;
    background-color: #ccc;
    color: #fff;
    width: 680px;
    height: 72px;
    margin: 64px auto;
    border-radius: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .van-cell{
    /* display: block; */
    display: flex;
  }
  </style>
    